import { render, staticRenderFns } from "./EditorLabel.vue?vue&type=template&id=966874c8&scoped=true"
import script from "./EditorLabel.vue?vue&type=script&lang=js"
export * from "./EditorLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966874c8",
  null
  
)

export default component.exports